var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"nav_btn",attrs:{"large":"","fixed":"","top":"","left":"","id":"btn-back"},on:{"click":_vm.route}},[_c('v-icon',{staticClass:"nav_icon",attrs:{"x-large":""}},[_vm._v("chevron_right")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }